export interface ResolvePreMeetingTitleParams {
  /** User-edited title. Whitespace-only falls through to the next tier. */
  editedTitle?: string;
  /** Selected calendar event's title. */
  meetingTitle?: string;
  /** Uploaded file name, extension included (upload surface only). */
  fileName?: string;
  /** Generated default, e.g. `Meeting on 8/25/2026`. */
  defaultTitle: string;
}

/** `notes.v2.m4a` → `notes.v2`; a name with no extension is kept whole. */
export const stripFileExtension = (fileName: string): string =>
  fileName.replace(/\.[^./]+$/, "");

export const resolvePreMeetingTitle = ({
  editedTitle,
  meetingTitle,
  fileName,
  defaultTitle,
}: ResolvePreMeetingTitleParams): string => {
  const edited = editedTitle?.trim();
  if (edited) return edited;

  const fromMeeting = meetingTitle?.trim();
  if (fromMeeting) return fromMeeting;

  const fromFileName = fileName ? stripFileExtension(fileName).trim() : "";
  if (fromFileName) return fromFileName;

  return defaultTitle;
};
